'use client';

import { VpIcon } from '@vtmn-play/react';
import useConfig from '@/hooks/useConfig';
import WidgetCategoryItem from './WidgetCategoryItem';
import { useTranslations } from 'next-intl';
import StepContainer from '../StepContainer/StepContainer';
import { useWidgetStore } from '@/providers/widget.provider';
import { Category } from '@repo/common/interfaces';
import Callout from '@repo/ui/Callout';
import { useTrackingAnalytics } from '@/providers/tracking.provider';
import { TrackingEvent } from '@/interfaces/tracking.interface';

import './WidgetCategoryStep.scss';

interface WidgetCategoryStepProps {
  categories?: Category<string>[];
}

const WidgetCategoryStep = ({ categories }: WidgetCategoryStepProps) => {
  const t = useTranslations('Widget.pages.steps.categories.content');
  const { currentStep, goToNextStep } = useConfig();
  const { setCategoryType } = useWidgetStore((state) => state);
  const { trackEvent } = useTrackingAnalytics();

  const handleCategoryOnClick = (category: Category<string>) => {
    setCategoryType(category.type);

    trackEvent(TrackingEvent.CATEGORY_SELECTED, {
      page_name: currentStep?.id,
      category_id: category.type,
      category_name: category.type,
    });

    goToNextStep(
      new URLSearchParams({
        category: category?.type,
      }),
    );
  };

  return (
    <StepContainer className='widget-categories-step'>
      {categories?.length === 0 && (
        <div className='flex flex-col items-center justify-center'>
          <VpIcon name='warning-error' />
          <p className='text-center vp-body-s'>{t('empty')}</p>
        </div>
      )}

      {t.has('information') && t('information').trim().length > 0 && (
        <Callout icon='information'>{t('information')}</Callout>
      )}

      <ul>
        {categories?.map((category: Category<string>) => (
          <li key={category?.type}>
            <WidgetCategoryItem
              onClick={() => handleCategoryOnClick(category)}
              category={category}
            />
          </li>
        ))}
      </ul>
    </StepContainer>
  );
};

export default WidgetCategoryStep;
